
(() => {
  function initCottivaaDiwali() {
    const root = document.getElementById('cottivaa-diwali');

    if (!root || root.dataset.initialized === 'true') return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.remove();
      return;
    }

    const particles = root.querySelector('.cottivaa-diwali-particles');
    if (!particles) return;

    root.dataset.initialized = 'true';

    // Falling gold particles
    for (let i = 0; i < 12; i++) {
      const sparkle = document.createElement('span');
      sparkle.className = 'cottivaa-sparkle';

      sparkle.style.setProperty('--sparkle-size', `${2 + Math.random() * 2}px`);
      sparkle.style.setProperty('--sparkle-duration', `${10 + Math.random() * 8}s`);
      sparkle.style.setProperty('--sparkle-delay', `${-Math.random() * 18}s`);

      particles.appendChild(sparkle);
    }

    // Falling light trails
    for (let i = 0; i < 2; i++) {
      const trail = document.createElement('span');
      trail.className = 'cottivaa-sparkle-trail';

      trail.style.setProperty('--trail-x', `${10 + Math.random() * 80}%`);
      trail.style.setProperty('--trail-height', `${45 + Math.random() * 55}px`);
      trail.style.setProperty('--trail-duration', `${6 + Math.random() * 5}s`);
      trail.style.setProperty('--trail-delay', `${-Math.random() * 10}s`);

      particles.appendChild(trail);
    }

    const colors = [
      '#ffb300',
      '#ff6d00',
      '#ff1744',
      '#ffeb3b',
      '#ff9100',
      '#ffffff'
    ];

    let lastLaunch = 0;

    function launchFirework() {
      if (!root.isConnected || document.hidden) return;

      // Keep at least 2.8 seconds between launches.
      const now = Date.now();
      if (now - lastLaunch < 2800) return;
      lastLaunch = now;

      // Keep fireworks away from the extreme page edges.
      const x = 12 + Math.random() * 76;
      const y = 15 + Math.random() * 36;
      const rocketHeight = Math.round(window.innerHeight * (0.55 + Math.random() * 0.2));
      const duration = 1300 + Math.random() * 500;

      const rocket = document.createElement('span');
      rocket.className = 'cottivaa-rocket';
      rocket.style.setProperty('--rocket-x', `${x}%`);
      rocket.style.setProperty('--rocket-height', `${rocketHeight}px`);
      rocket.style.setProperty('--rocket-duration', `${duration}ms`);

      particles.appendChild(rocket);


  rocket.addEventListener('animationend', () => {
    rocket.remove();

    const burst = document.createElement('span');
    burst.className = 'cottivaa-firework';
    burst.style.setProperty('--burst-x', `${x}%`);
    burst.style.setProperty('--burst-y', `${y}%`);
    particles.appendChild(burst);

    const count = 64;
    const fireworkColors = [
      '#ffbd38',
      '#ff6d00',
      '#ffec99',
      '#ffffff',
      '#f58a27'
    ];

    // Large radial firework burst
    for (let i = 0; i < count; i++) {
      const particle = document.createElement('span');
      particle.className = 'cottivaa-firework-particle';

      const angle = (Math.PI * 2 * i) / count;
      const distance = 55 + Math.random() * 100;

      particle.style.setProperty(
        '--burst-dx',
        `${Math.cos(angle) * distance}px`
      );
      particle.style.setProperty(
        '--burst-dy',
        `${Math.sin(angle) * distance}px`
      );
      particle.style.setProperty(
        '--particle-size',
        `${2 + Math.random() * 4}px`
      );
      particle.style.setProperty(
        '--particle-color',
        fireworkColors[Math.floor(Math.random() * fireworkColors.length)]
      );
      particle.style.setProperty(
        '--burst-duration',
        `${900 + Math.random() * 700}ms`
      );

      burst.appendChild(particle);
    }

    // Reveal the COTTIVAA brand in the fireworks
    const brand = document.createElement('div');
    brand.className = 'cottivaa-brand-reveal';
    brand.textContent = 'COTTIVAA';
    brand.style.setProperty('--brand-x', `${x}%`);
    brand.style.setProperty('--brand-y', `${y}%`);

    particles.appendChild(brand);

    // Remove temporary elements after their animations finish
    window.setTimeout(() => burst.remove(), 1800);
    window.setTimeout(() => brand.remove(), 3400);
  }, { once: true });


      // Clean up if animation is interrupted.
      window.setTimeout(() => rocket.remove(), duration + 1500);
    }

    // Launch the first rocket after the page settles.
    window.setTimeout(launchFirework, 1200);

    // Continue occasional launches, without launching while the tab is hidden.
    window.setInterval(() => {
      if (!document.hidden) launchFirework();
    }, 7000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCottivaaDiwali, { once: true });
  } else {
    initCottivaaDiwali();
  }
})();